/* eslint-disable jsx-a11y/anchor-is-valid */
/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/
import { fetchPhpEigth } from "api";
import classnames from "classnames";
import Breadcrumcomponent from "components/BreadCrumbMex/BreadCrumb";
import BreadCrumbPasosV2 from "components/BreadCrumbMex/BreadCrumbPasosV2";
import Page from "components/Page";
import ModalOcupaciones from "components/TravelMex/ModalOcupaciones";
import { ALBERT_EVENTS } from "constants/albert_events";
import { ambienteAplicacion, urlGetPlanes, urlGuardarPlanes } from "constants/urls";
import useAlbert from "hooks/useAlbert";
import withValidarRecuperar from "HOC/withValidarRecuperar";
import useB4BreakPoints from "hooks/useB4BreakPoints";
import useCustomRouter from "hooks/useCustomRouter";
import useCustomToast from "hooks/useCustomToasts";
import useQueryParams from "hooks/useQueryParams";
import { TabPanel, TabView } from "primereact/tabview";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { setBanderaPrimerPago } from "redux/actions/cotizacion.actions";
import styled from "styled-components";
import { PASOS_BREADCRUMBS } from "utils/constants";
import COLORS from "utils/constants/COLORS";
import PRODUCTOS from "utils/constants/PRODUCTOS";
import { getColorByIndex } from "utils/funciones";
import Loading from "wrappers/Loading";
import { match } from "x-match-expression";
import "./styles.scss";

const SeleccionarPlanContainer = ({ dataUsuario, ...props }) => {
  const { cliCodigoCore } = dataUsuario;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [planSeleccionado, setPlan] = useState(0);
  const [ocupaciones, setOcupaciones] = useState([]);
  const { addWarningToast } = useCustomToast();
  const history = useCustomRouter();
  const { recuperar } = useQueryParams();
  const { idCotizacion } = useParams();

  const dispatch = useDispatch();

  const { inSm, inXs, inMd, inLg, inXl } = useB4BreakPoints();
  const { addApEvent } = useAlbert();
  const predicateSeleccionado = (item) => item.seleccionado === true;

  const getData = async () => {
    setLoading(true);

    const Data = {
      prodCodigo: PRODUCTOS.APINDIVIDUAL,
      ambiente: ambienteAplicacion,
      recuperar: !!recuperar,
      cotCodigo: idCotizacion,
      cliCodigoCore: cliCodigoCore || "",
      datosCotizador: {
        prodCodigo: PRODUCTOS.APINDIVIDUAL,
        catPasoCodigo: "planes",
        idCotizacion,
      },
    };

    if (cliCodigoCore) {
      Data.datosCotizador.usuCotiza = {
        usuCodigo: cliCodigoCore,
      };
    }

    const res = await fetchPhpEigth(urlGetPlanes, Data);

    if (res?.transaccion && res?.data) {
      const { catalogo } = res?.data;
      dispatch(setBanderaPrimerPago(catalogo?.banderaPrimerPago || false));

      setOcupaciones(catalogo?.ocupacionesExclusion);

      const planes = catalogo?.planes;

      setData(planes);

      const prodSelect = planes.find(predicateSeleccionado);
      const planSelect = planes.flatMap((item) => item.planes).find(predicateSeleccionado);

      setPlan(planSelect);

      const index = planes.indexOf(prodSelect);
      setTabIndex(index);
      setLoading(false);
    } else {
      history.goBack();
      try {
        return res.errorDescripcion.forEach(addWarningToast);
      } catch (error) {
        return addWarningToast("Ha ocurrido un problema al consultar los valores");
      }
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const mapProductos = (producto, plan) => {
    const newProductos = data.map((item) => ({
      ...item,
      seleccionado: item.id === producto.id ? true : undefined,
      planes: item?.planes.map((subPlan) => ({
        ...subPlan,
        seleccionado: item.id === producto.id && subPlan.id === plan.id ? true : undefined,
      })),
    }));
    setData(newProductos);
  };

  const onClickSeleccionar = (plan, producto) => (event) => {
    try {
      setPlan(plan);
      mapProductos(producto, plan);
    } catch (error) {}
  };

  const onChangeTab = ({ index }) => {
    mapProductos(data?.[index], data?.[index].planes[0]);
    setPlan(data?.[index].planes[0]);
    setTabIndex(index);
  };

  const onContinuar = async () => {
    setLoading(true);

    const Data = {
      ambiente: ambienteAplicacion,
      prodCodigo: PRODUCTOS.APINDIVIDUAL,
      pasoCodigo: "planSelecionado",
      tarifacionPantallaDos: false,
      idCotizacion,
      usuCotiza: cliCodigoCore || "",
      items: {
        idCotizacion: idCotizacion,
        planes: data,
      },
    };

    const res = await fetchPhpEigth(urlGuardarPlanes, Data);

    if (res.transaccion) {
      addApEvent(ALBERT_EVENTS.CHOOSE_PLAN);
      history.push(`/accidentes-resumen-personas/${idCotizacion}`);
    }

    setLoading(false);
  };

  const onClickAtras = () => {
    history.push(`/accidentes-personas/${idCotizacion}`);
  };

  const setTabMargin = () => {
    if (inXs) {
      return "2rem";
    }

    if (inSm) {
      return "10rem";
    }

    if (inMd) {
      return "15rem";
    }

    if (inLg) {
      return "20rem";
    }
    if (inXl) {
      return "23rem";
    }
  };

  const footer = useMemo(
    () => (
      <React.Fragment>
        <ModalOcupaciones
          ocupaciones={ocupaciones}
          baseClassName='w-100 text-center text-xl-left'
        />
        <h4 className='text-primary' style={{ marginTop: "4rem" }}>
          *referencia sobre la prima neta total diferida a 12 pagos mensuales
        </h4>
      </React.Fragment>
    ),
    [ocupaciones]
  );

  return (
    <React.Fragment>
      <Loading loading={loading}>
        <div className='cr-content'>
          <Page>
            <Breadcrumcomponent
              title='Cotización Accidentes Personales'
              subtitle='Cotización Accidentes Personales'
            />

            <BreadCrumbPasosV2
              {...PASOS_BREADCRUMBS[PRODUCTOS.APINDIVIDUAL].breadCrumbPasosCotizacion[2]}
              pasos={PASOS_BREADCRUMBS[PRODUCTOS.APINDIVIDUAL]?.pasosCotizacion}
            />

            <TabView className='my-5' activeIndex={tabIndex} onTabChange={onChangeTab}>
              {data.map((item, index) => (
                <TabPanel
                  headerStyle={{
                    marginLeft: index === 0 && setTabMargin(),
                    fontSize: "20px",
                  }}
                  header={<h1 style={{ fontSize: "25px" }}>{item.producto}</h1>}
                  key={index}
                  contentStyle={{ margin: "0 0 0 0", padding: "0 0 0 0" }}>
                  <div
                    className='row my-5 justify-content-around'
                    style={{ margin: "0 0 0 0", padding: "0 0 0 0" }}>
                    <div className='col-10 col-xl-3 cob-des-padding d-none d-xl-block no-gutters '>
                      <div className='d-flex flex-column h-100'>
                        <div
                          style={{
                            marginTop: "8rem",
                            height: "120px",
                          }}>
                          <h4 className='font-mex' style={{ fontSize: "25px" }}>
                            Coberturas
                          </h4>
                        </div>
                        {planSeleccionado &&
                          planSeleccionado.coberturas.map((cobertura, index) => (
                            <CoberturaXL key={index} length={cobertura?.nombre?.length}>
                              {cobertura.nombre}
                            </CoberturaXL>
                          ))}

                        {footer}
                      </div>
                    </div>

                    {item.planes.map((plan, index) => (
                      <React.Fragment key={plan.id}>
                        <div
                          className='col-10 col-md-8 col-lg-5 col-xl-2 ap mb-5 mb-xl-0 cpointer'
                          key={index}
                          onClick={onClickSeleccionar(plan, item)}>
                          <div
                            className={classnames("row plan-accidentes", {
                              selected: plan.seleccionado,
                            })}>
                            <div className='col-12'>
                              <div className='row justify-content-center mt-4 mb-5'>
                                <div
                                  className='text-center'
                                  style={{
                                    backgroundColor: getColorByIndex(index),
                                    fontSize: "20px",
                                    paddingBottom: "0.5rem",
                                    width: "100%",
                                  }}>
                                  <h4 className='font-mex text-mex mt-2'>{plan.producto}</h4>
                                </div>

                                <div className='col-12'>
                                  <div className='text-center'>
                                    <div style={{ height: "120px" }}>
                                      <h6 className='font-source-sans-regular text-mex my-3'>
                                        Prima total anual
                                      </h6>
                                      <h5
                                        className='font-mex text-mex mt-3'
                                        style={{
                                          fontSize: "30px",
                                          fontWeight: "bold",
                                        }}>
                                        ${plan.precioFormatoAnual}
                                      </h5>

                                      <h6 style={{ color: COLORS.cyan }}>
                                        desde ${plan.precioFormatoMensual} pago mensual*
                                      </h6>
                                    </div>

                                    <div className='font-source-sans-regular mt-5 text-right'>
                                      {plan.coberturas.map((cob, index) => {
                                        return (
                                          <React.Fragment key={index}>
                                            <CoberturaXL
                                              length={cob?.nombre?.length}
                                              className='d-none d-xl-block text-center'>
                                              {cob.precio}
                                            </CoberturaXL>
                                            <div className='d-block d-xl-none'>
                                              <div
                                                className='row justify-content-around'
                                                style={{
                                                  margin: "0 0 0 0",
                                                  padding: "0 0 0 0",
                                                }}>
                                                <div className='col-7'>
                                                  <p
                                                    className='cobertura text-right'
                                                    style={{
                                                      color: "#151515",
                                                      fontSize: "20px",
                                                    }}>
                                                    {cob.nombre}
                                                  </p>
                                                </div>
                                                <div className='col-5 text-center'>
                                                  <p
                                                    className='cobertura'
                                                    style={{
                                                      color: "#151515",
                                                      height: "40px !important",
                                                      fontSize: "20px",
                                                    }}>
                                                    {cob.precio}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          </React.Fragment>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className='row justify-content-center mt-3'>
                            <button
                              className={classnames("btn-select-plan-ap text-uppercase", {
                                selected: plan.seleccionado,
                              })}
                              type='button'
                              style={{
                                fontSize: "19px",
                                borderRadius: "0",
                                outline: "none",
                              }}>
                              Elijo este plan
                            </button>
                          </div>
                        </div>
                      </React.Fragment>
                    ))}
                    <div className='w-100 text-center mt-3 d-xl-none'>{footer}</div>
                  </div>
                </TabPanel>
              ))}
            </TabView>

            <div className='row justify-content-center my-5'>
              <div className='col-4 col-md-3 col-xl-2'>
                <button className='btn btn-atras-api' onClick={onClickAtras}>
                  Atrás
                </button>
              </div>
              <div className='col-4 col-md-3 col-xl-2'>
                <button className='btn btn-siguiente-api' onClick={onContinuar}>
                  Siguiente
                </button>
              </div>
            </div>
          </Page>
        </div>
      </Loading>
    </React.Fragment>
  );
};

export default withValidarRecuperar(SeleccionarPlanContainer);

const CoberturaXL = styled.div`
  height: ${(props) =>
    match(props.length)
      .case((n) => n >= 0 && n <= 30, "30px")
      .case((n) => n >= 31 && n <= 80, "60px")
      .case((n) => n >= 81 && n <= 85, "80px")
      .case((n) => n >= 91 && n <= 120, "120px")
      .case((n) => n >= 91 && n <= 120, "120px")
      .default("120px")};
  font-size: 20px;

  color: #151515;
  margin: 1px 0 1rem 0;
  @media (min-width: 1290px) {
    height: ${(props) =>
      match(props.length)
        .case((n) => n >= 0 && n <= 30, "20px")
        .case((n) => n >= 31 && n <= 50, "30px")
        .case((n) => n >= 51 && n <= 80, "50px")
        .case((n) => n >= 81 && n <= 85, "60px")
        .case((n) => n >= 91 && n <= 120, "100px")
        .default("100px")};
  }
  align-items: center;

  & .info {
    font-weight: bold;
  }
`;
